/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import TaxAccountDetailsPopup from "../../../../components/Accounts/TaxAccount/TaxAccountDetailsPopup/index.jsx";
import Loader from "../../../../components/Loader/Index";
import CommonAccountApprovalCard from "../../../../components/_utils/CommonAccountApprovalCard/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import {
  taxCompliantAccountApprove,
  taxCompliantAccountReject,
} from "../../../../redux/features/accounts/taxAccount/taxAccountApproval.js";
import { getTaxSections } from "../../../../redux/features/accounts/taxAccount/taxAccountCreateEdit.js";
import { taxCompliantAccountDetail } from "../../../../redux/features/accounts/taxAccount/taxAccountDetails.js";
import {
  TaxAddNewLabel,
  taxCompliantViewAll,
  TaxRemoveNewLabel,
} from "../../../../redux/features/accounts/taxAccount/taxAccountViewAll.js";
import {
  beneBankLookUp,
  setToggle,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { rejectTdsTransaction } from "../../../../redux/features/transactions/taxTransaction/taxTransactionApproval.js";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import { linkIdentifier } from "../../../../utils/linkIdentifier.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import TaxationTransactionViewAll from "../../../Transactions/TaxationTransactions/TaxationTransactionViewAll/index.jsx";
import TaxationAccountViewAll from "../TaxationAccountViewAll/index.jsx";

const TaxationAccountApproval = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const sidebarRef = useRef(null);
  const dropdownRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const sidebarButtonRef = useRef(null);
  const searchBarRefSecond = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });
  const [associatePopupDate, setAssociatePopupDate] = useState({
    panNumber: "",
    ifscCode: "",
    accNumber: "",
    accId: "",
    accName: "",
  });
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [remPan, setRemPan] = useState("");
  const [labels, setLabels] = useState([]);
  const [isIfsc, setIsIfsc] = useState(searchParam.get("ifsc") || "");
  const [active, setActive] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [loading, setLoading] = useState({});
  const [labelId, setLabelId] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [fileType, setFileType] = useState(searchParam.get("createdVia") || "");
  const [pageSize, setPageSize] = useState(50);
  const [mainData, setMainData] = useState([]);
  const [deniedId, SetDeniedId] = useState(null);
  const [inputData, setInputData] = useState([]);
  const [panNumber, setPanNumber] = useState(searchParam.get("pan") || "");
  const [btnClicked, setBtnClicked] = useState({});
  const [taxSection, setTaxSection] = useState(
    searchParam.get("taxSection") || "",
  );
  const [remAccount, setRemAccount] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [activeType, setActiveType] = useState("pan");
  const [taxAccountId, SetTaxAccountId] = useState("");
  const [isAlertPopup, setIsAlertPopUp] = useState(false);
  const [accountNumber, setAccountNumber] = useState(
    searchParam.get("accno") || "",
  );
  const [declineReason, setDeclineReason] = useState("");

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [associateType, setAssociateType] = useState("");
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [taxLoadingData, setTaxLoadingData] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [showRejectTxnPopup, setRejectTxnPopup] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [isTaxDetailPopup, setIsTaxDetailPopup] = useState(false);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [allTaxAccountLoading, setAllTaxAccountLoading] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const dropdownOptions =
    window.innerWidth < 1600
      ? [50, 100]
      : window.innerWidth < 2560
        ? [50, 100]
        : [50, 100];
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);

  const services = useSelector((state) => state.refreshToken.services);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const { tdsTxnViewAllData, tdsTxnViewAllLoading } = useSelector(
    (state) => state.tdsTxnViewAll,
  );
  const sliceCategory = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { approveData, approveLoading } = useSelector((state) => {
    return state.taxCompliantApproveRejectAccount;
  });

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };

  const hasAnyFilter =
    // Boolean(currentCategory?.length) ||
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    fileType !== "" ||
    Boolean(isIfsc) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allTaxAccountLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allTaxAccountLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const handleInputChange = (event) => {
    let value = event?.target?.value;
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    value = value.slice(0, 150);

    setDeclineReason(value);
  };

  const fetchTaxAccountData = async () => {
    let response;
    let data = [];
    setTaxLoadingData(true);

    switch (active) {
      // case "Tax type":
      //   response = await dispatch(
      //     getTaxSections({ section_name: searchUserTextDebounce }),
      //   );
      //   console.log("response", response);
      //   data = response?.map((itm) => {
      //     return {
      //       id: itm?.name,
      //       category: itm?.name,
      //       Description: itm?.description || "Not given",
      //     };
      //   });
      //   setInputData(data);
      //   setTaxLoadingData(false);
      //   break;
      case "Tax section":
        response = await dispatch(
          getTaxSections({
            section_name: searchUserTextDebounce,
          }),
        );

        data = response?.payload?.map((itm) => ({
          id: itm?.section_name,
          Tax_section_name: itm?.section_name,
          Description: itm?.description || "Not given",
        }));
        setInputData(data);
        setTaxLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setTaxLoadingData(false);
        break;
      default:
        break;
    }
  };

  const fetchData = async () => {
    try {
      setAllTaxAccountLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        approval_status: "pending",
        sort_by: accountbalancestate === "Oldest first" ? "oldest" : "latest",
      };
      if (currentCategory !== "") {
        queryParams.category = currentCategory;
      }
      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter !== GlobalConfiguration?.lengthCheckZero &&
        endDateFilter !== GlobalConfiguration?.lengthCheckZero &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date = startDateFilter;
        queryParams.end_date = endDateFilter;
      }
      if (accountNumber !== "") {
        queryParams.bank_account_no = accountNumber;
      }

      if (taxSection !== "") {
        queryParams.section_name = taxSection;
      }

      if (fileType) {
        queryParams.created_via = fileType;
      }
      if (panNumber !== "") {
        queryParams.pan = panNumber;
      }
      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }
      if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (isIfsc !== "") {
        queryParams.ifsc = isIfsc;
      }

      const response = await dispatch(taxCompliantViewAll(queryParams));

      const newData = (response?.payload?.tds_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setMainData(response?.payload);
      setLabels(response?.payload?.summary?.available_labels);

      const rawData = response?.payload?.tds_accounts || [];
      setAccumulatedData(rawData);
    } catch (error) {
      console.error("Error fetching tds accounts:", error);
    } finally {
      setAllTaxAccountLoading(false);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(currentPage));
    toggleDropdown();
  };

  const filteredData = accumulatedData;

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetDeniedId(id);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
    setShowRejectPopup(false);
    setBtnClicked({});
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      setLabelId([]);

      fetchData();
    }
  };

  const onClose = () => {
    setShowRejectPopup(false);
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Account approved successfully.",
      icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const handleApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");
    setBtnClicked((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: "Approve",
    }));

    const data = await dispatch(taxCompliantAccountApprove({ id: id }));

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BTDSAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;

      if (errors?.tds_accounts?.[0]) {
        errorMessage = errors.tds_accounts[0];
      } else if (errors?.bank_acc_no?.[0]) {
        errorMessage = errors.bank_acc_no[0];
      } else if (!data?.payload?.status) {
        errorMessage = errors?.category?.[0];
      } else {
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data?.payload?.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data?.payload?.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data?.payload?.status === false) {
            const errors = data?.payload?.errors;
            if (errors?.tds_accounts?.[0]) {
              message = errors.tds_accounts[0];
            } else if (data?.payload?.errors === "false") {
              message = errors?.category?.[0];
            } else if (errors?.bank_acc_no?.[0]) {
              message = errors.bank_acc_no[0];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data?.payload?.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (data.payload.status === true) {
        handleApprovalToastSuccess();
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleOpenTaxDetailPopup = async (id) => {
    SetTaxAccountId(id);
    setIsTaxDetailPopup(!isTaxDetailPopup);
  };
  const handleCloseTaxDetailPopup = () => {
    setIsTaxDetailPopup(false);
  };

  const openAssociatedAccountsFound = (ifsc_code, acc_no, pan_no, id) => {
    dispatch(beneLookUp({ pan_number: pan_no }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc_code,
        bank_account_no: acc_no,
      }),
    );
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        ifscCode: ifsc_code,
        accNumber: acc_no,
        accId: id,
        panNumber: pan_no,
      };
    });

    setRemPan(pan_no);
    setOpenBeneAssociate(true);
  };

  const openTxnPopup = (id, acc_Name) => {
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        accId: id,
        accName: acc_Name,
      };
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefSecond.current &&
        !searchBarRefSecond.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarButtonRef.current &&
        !sidebarButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClearFilters = () => {
    setAllTaxAccountLoading(true);
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setCurrentCategory("");
    setTaxSection("");
    setPanNumber("") ||
      setAccountNumber("") ||
      setIsIfsc("") ||
      setLabelSearchText("");
    setSearchUserTextDebounce("");
    setSearchUserText("");
    setFileType("");
    setaccountbalancestate("");
  };

  useEffect(() => {
    if (active?.length) {
      fetchTaxAccountData();
    }
  }, [active]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    currentPage,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    searchUserText,
    isIfsc,
    LabelSearchText,
    currentCategory,
    taxSection,
    fileType,
    accountbalancestate,
  ]);

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleRejectTransactionChecker = async () => {
    // setShowLoader(true);
    // setTimeout(() => setShowLoader(false), IntervalConfiguration.intervalLarge);
    setShowPopup(false);

    const accountInfo = await dispatch(
      taxCompliantAccountDetail(btnClicked?.id),
    );

    if (
      accountInfo?.payload?.tds_accounts?.[0]?.pending_tds_transactions === "Y"
    ) {
      setRejectTxnPopup(true);
    } else {
      handleRejectBeneTxn();
    }
  };

  const handleRejectBeneTxn = async () => {
    try {
      setShowLoader(true);
      UniversalRefreshToast("accountsRefresh");

      const data = await dispatch(
        taxCompliantAccountReject({
          id: btnClicked?.id,
          rejectionReason: declineReason,
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setAllAccounts((prev) =>
          prev.map((acc) =>
            acc.id === btnClicked.id
              ? {
                  ...acc,
                  approval_status: "rejected",
                  rejection_reason: declineReason,
                  error: "false",
                }
              : acc,
          ),
        );
      }

      setShowPopup(false);
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoader(false);
      setDeclineReason("");
      setBtnClicked({});
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllTaxAccountLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelId);
    const res = await dispatch(
      TaxAddNewLabel({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (TaxAddNewLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (TaxAddNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setAllTaxAccountLoading(false);
    if (TaxAddNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllTaxAccountLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelId);
    const res = await dispatch(
      TaxRemoveNewLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (TaxRemoveNewLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (TaxRemoveNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    await fetchData();
    if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    setAllTaxAccountLoading(false);
  };

  const handleCardClick = (targetPath) => {
    setPendingNavTarget(targetPath);
    setIsAlertPopUp(true);
  };

  const handleLeaveConfirm = () => {
    setIsAlertPopUp(false);
    setOpenBeneAssociate(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setIsAlertPopUp(false);
    setPendingNavTarget(null);
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleRejectTxn = async () => {
    setShowLoader(true);
    setShowPopup(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !tdsTxnViewAllLoading &&
      tdsTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? tdsTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        rejectTdsTransaction({ id: id2, accountIdData: AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "ATDSTransaction";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
      await dispatch(taxCompliantViewAll());
      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setTimeout(() => {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);

      const updatedData = allAccounts?.map((item) => {
        if (item.id === btnClicked?.id) {
          return {
            ...item,
            pending_tds_transactions: "N",
          };
        }
        return item;
      });

      updateAllAccounts(updatedData);
      setBtnClicked((item) => {
        return {
          ...item,
          [btnClicked?.id]: "none",
        };
      });

      if (associateType !== "rejectAccount") {
        await dispatch(taxCompliantViewAll());
      }
      if (associateType === "rejectAccount") {
        handleRejectBeneTxn();
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
      await dispatch(taxCompliantViewAll());
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
  };

  return (
    <>
      {showRejectTxnPopup && (
        <LargePopupRedirect
          headerTitle="Associated transactions found"
          headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setRejectTxnPopup(false);
            setDeclineReason("");
            setShowLoader(false);
            setBtnClicked((item) => {
              return {
                ...item,
                [btnClicked?.id]: "none",
              };
            });
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            if (associateType === "TaxAccountTxn") {
              setShowPopup(true);
            } else {
              handleRejectTxn();
            }
          }}
          isLoaderNeeded={true}
          isLoading={showLoader ? true : false}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <TaxationTransactionViewAll
            txnHistoryid={btnClicked?.id}
            type={"tax_txnViewAll_popup"}
            flow={"Tax_txnViewAll_popup_reject"}
          />
        </LargePopupRedirect>
      )}
      {isAlertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Open in full view?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {openBeneAssociate && (
        <LargePopupRedirect
          headerTitle="Associated accounts"
          headersubtext="The accounts listed below are linked to the selected tax account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setOpenBeneAssociate(false);
            setRemPan("");
            setRemAccount("");
            setRemIFSC("");
            setActiveType("pan");
            dispatch(setToggle(false));
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          confirmbtnrequired={true}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
          ispanbankRequired={true}
          togglepan={() => {
            setActiveType("pan");
            setRemPan(associatePopupDate?.panNumber);
            setRemAccount("");
            setRemIFSC("");
            // setSearchPanText(associatePopupDate?.panNumber);
          }}
          toggleBank={() => {
            setActiveType("bank");
            setRemPan("");
            setRemAccount(associatePopupDate?.accNumber);
            setRemIFSC(associatePopupDate?.ifscCode);
            // setSearchPanText(associatePopupDate?.panNumber);
          }}
        >
          <TaxationAccountViewAll
            // id={associatePopupDate?.accId}
            type={"TaxAcc"}
            remPan={remPan}
            remAccount={remAccount}
            remIFSC={remIFSC}
            activeType={activeType}
            // searchPanText={searchPanText}
            currentAccountDetails={associatePopupDate}
            setOpenBeneAssociate={setOpenBeneAssociate}
            onCardNavigate={handleCardClick}
          />
        </LargePopupRedirect>
      )}

      {isLabelPopupOpen && (
        <div
          onClick={() => {
            setIsLabelPopupOpen(false);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
          max-zindex
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={(filteredData || []).filter((acc) =>
              Array.isArray(labelId)
                ? labelId.includes(acc?.id)
                : labelId === acc?.id,
            )}
            onClose={handleClose}
            loading={allTaxAccountLoading}
            setLoading={setAllTaxAccountLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {/* Popup for entering reason for declining account & transaction */}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            // noteText="The reason must consist of at least 10 characters."
            noteColor="text-secondary"
            inputPlaceholder="Reason (10-150 char)"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            // End of Input Field Props
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              // if (!showLoader) {
              handleClosePopup();

              // }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "TaxAccountTxn") {
                handleRejectTxn();
              } else {
                handleRejectTransactionChecker();
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {isTaxDetailPopup && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={handleCloseTaxDetailPopup}
        >
          <TaxAccountDetailsPopup
            closeBeneAccountDetailModal={handleCloseTaxDetailPopup}
            tax_account_id={taxAccountId}
            type={"tax_account_detail_modal"}
            headerTitle="Tax account details"
          />
        </div>
      )}

      <div className="h-screen overflow-hidden flex flex-col">
        <div className="relative z-z-index-content bg-primary-nav min-h-0 Qmd:min-h-navbar-breadcrumb-height"></div>
        <div className="w-full relative z-z-index-header lg:px-padding-base flex items-center justify-end m-auto">
          <TopNavComponent
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allTaxAccountLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search tax account",
              filterPlaceholder:
                "Name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Account number",
                  short_name: "Tax Acc",
                  isMulti: false,
                  value: accountNumber,
                  setValue: (val) => {
                    handleSubmit("accno", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAccountNumber(val);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value: isIfsc.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("ifsc", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setIsIfsc(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value: panNumber.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("pan", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setPanNumber(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: false,
                },

                // {
                //   name: "Tax type",
                //   short_name: "Typ",
                //   valueType: "string",
                //   isMulti: false,
                //   value: currentCategory,
                //   setValue: (val) => {
                //     setCurrentPage(GlobalConfiguration.lengthCheckOne);
                //     handleSubmit("category", val);
                //     setCurrentCategory(val);
                //   },
                //   isDropdown: true,
                //   isDisabled: false,
                // },
                {
                  name: "Tax section",
                  short_name: "Sec",
                  valueType: "string",
                  isMulti: false,
                  value: taxSection,
                  setValue: (val) => {
                    handleSubmit("taxSection", val);
                    setTaxSection(val);
                  },
                  isDropdown: true,
                  isDisabled: false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    handleSubmit("label", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: false,
                },
              ],
              filters: [
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    handleDateChange(date);
                  },
                },
                {
                  name: "Created via",
                  filterType: "dropdown",
                  variant: "single",
                  isSearch: false,
                  options: ["Manual", "File upload"],
                  searchPlaceholder: "Select",
                  dropdownPlaceHolder: "Select",
                  value: fileType,
                  handleChange: (val) => {
                    handleSubmit("createdVia", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setFileType(val);
                  },
                },
              ],
              sortByFilter: [
                {
                  name: "Newest first",
                  default: true,
                  isDisabled: false,
                },
                {
                  name: "Oldest first",
                  isDisabled: false,
                },
              ],
              sortValue: accountbalancestate,
              sortHandleChange: (val) => {
                handleSubmit("sort", val);
                setaccountbalancestate(val);
              },
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                fileType !== ""
              ),
              isSearchClearAllDisabled: !(
                currentCategory !== "" ||
                taxSection !== "" ||
                panNumber !== "" ||
                LabelSearchText?.length !==
                  GlobalConfiguration.lengthCheckZero ||
                isIfsc !== "" ||
                searchUserText !== "" ||
                accountNumber !== ""
              ),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: allTaxAccountLoading,
              loadingData: taxLoadingData,
              setLoading: setTaxLoadingData,
              isShowSortBy: true,
              isShowFilter: true,
            }}
          />
        </div>
        <div
          className={`flex-1 flex flex-col overflow-hidden relative ${showInnerSearchBar ? "pointer-events-none" : ""}`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content "></div>
          )}
          <div
            style={{
              paddingBottom:
                approveData?.summary?.pending_accounts_count === undefined &&
                "var(--padding-md)",
            }}
            className={`flex flex-col flex-1 items-center overflow-auto overflow-x-hidden w-full pb-padding-lg ${allTaxAccountLoading ? "h-full" : ""} `}
          >
            {allTaxAccountLoading ? (
              <div className="loader-container m-auto justify-center items-center flex">
                <Loader />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className="bene-acc-no-beneaccount-text my-margin-sm">
                  No data found.
                </p>

                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  btnType="button"
                  handleFunction={handleClearFilters}
                  enabledTextColor="var(--text-primary)"
                  fullWidthRequired={false}
                />
              </div>
            ) : allAccounts?.length > GlobalConfiguration.lengthCheckZero ? (
              <div
                className="scroll flex flex-col items-center justify-center w-width-full"
                ref={filterRef}
              >
                <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base  gap-gap-md">
                  {allAccounts?.map((account, index) => {
                    const asAcc =
                      account?.associate_bank === "Y" ||
                      account?.associate_pan === "Y";

                    const pendingTxn =
                      account?.pending_tds_transactions === "Y";

                    const buildAlerts = () => [
                      ...(asAcc !== undefined
                        ? asAcc
                          ? [
                              {
                                isLoading: false,
                                text: "Associated accounts are found",
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  openAssociatedAccountsFound(
                                    account?.ifsc_code,
                                    account?.bank_acc_no,
                                    account?.pan_no,
                                    account?.id,
                                  );
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: "Checking associated account",
                            },
                          ]),
                      ...(pendingTxn !== undefined
                        ? pendingTxn && account?.approval_status === "pending"
                          ? [
                              {
                                isLoading: false,
                                isDisabled: false,
                                text: "Pending transactions found",
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  if (false) {
                                    actionRestricted();
                                    return;
                                  } else {
                                    const hasAccess =
                                      services?.includes("ATDSTransaction") ||
                                      services?.includes("Admin");

                                    if (!hasAccess) {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "ATDSTransaction",
                                        },
                                      });
                                      return;
                                    }
                                    setBtnClicked({
                                      id: account?.id,
                                    });
                                    setRejectTxnPopup(true);
                                    setAssociateType("TaxAccountTxn");
                                    // setSearchtype("rejectall");
                                  }
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: false,
                              text: "Checking pending transactions",
                            },
                          ]),
                    ];
                    return (
                      <div
                        key={account.id}
                        className={`w-full ${index === 0 ? "mt-margin-md" : ""}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={btnClicked?.[account?.id] ?? "none"}
                          entries={[
                            [
                              {
                                type: "textSubtext",
                                text: account.name,
                                subText: "Account name",
                              },
                              {
                                type: "textSubtext",
                                text: linkIdentifier(account?.email_id),
                                textColor: "var(--pending)",
                                subText: "Email ID",
                              },
                              {
                                type: "textSubtext",
                                text: "+91 " + account.contact_no,
                                subText: "Contact number",
                              },
                              {
                                type: "textSubtext",
                                text: "Pending",
                                subText: "Account",
                              },
                              {
                                type:
                                  account?.category?.toLowerCase() === "tds"
                                    ? "textSubtextX2"
                                    : "textSubtext",
                                text: (() => {
                                  const type = account?.category?.toLowerCase();
                                  if (!type) return "Not assigned";
                                  const special = ["gst", "pt", "tds"];
                                  if (special.includes(type)) {
                                    return type.toUpperCase();
                                  }
                                  return type
                                    .replace(/_/g, " ")
                                    .replace(/\b\w/g, (c) => c.toUpperCase());
                                })(),
                                subText: "Tax type",
                                text1:
                                  account?.tax_section?.section_name ||
                                  "Not available",
                                subText1: "Tax section",
                              },
                            ],

                            [
                              {
                                type: "textSubtext",
                                text: account.bank_account_holder_full_name
                                  ?.toLowerCase()
                                  ?.split(" ")
                                  ?.map(
                                    (w) =>
                                      w.charAt(0).toUpperCase() + w.slice(1),
                                  )
                                  ?.join(" "),
                                subText: "Bank account holder name",
                              },
                              {
                                type: "accountNumber",
                                text: account.bank_acc_no,
                                subText: "Account number",
                                ifsc: account.ifsc_code,
                              },
                              {
                                type: "textSubtext",
                                text: account.ifsc_code,
                                subText: "IFSC code",
                              },
                              {
                                type: "textSubtextX2",
                                text: account.pan_no,
                                subText: "PAN number",
                                text1: account.gstin_detail || "Not given",
                                subText1: "GSTIN",
                              },
                            ],

                            [
                              {
                                type: "cta",
                                text:
                                  account?.labels?.join(", ") ||
                                  "No labels assigned",
                                subText: "Labels",
                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setLabelId(account?.id);
                                    setIsLabelPopupOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                              {
                                type: "textSubtext",
                                text: account?.account_type,
                                subText: "Account",
                              },
                            ],
                          ]}
                          approveClick={() => handleApproval(account.id)}
                          rejectClick={() => {
                            handleOpenPopup(account?.id);
                            setDeclineReason("");
                            setActiveType("rejectAccount");
                            openTxnPopup(account?.id, account?.name);
                            setBtnClicked({
                              [account?.id]: "reject",
                              id: account?.id,
                            });
                            setAssociateType("rejectAccount");
                          }}
                          ctaBtn1Text={"More details"}
                          ctaBtn1OnClick={
                            account.approval_status === "pending" &&
                            !loading[account.id]
                              ? () => {
                                  handleOpenTaxDetailPopup(account.id);
                                }
                              : undefined
                          }
                          cardState={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveData &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveData &&
                            !loading[account.id]
                              ? "Approved"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveData &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            approveData &&
                            !loading[account.id]
                              ? ICONS?.APPROVED_GREEN_LINEAR
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? ICONS?.REJECTED_RED
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              approveData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              approveData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => {
                                  handleOpenTaxDetailPopup(account.id);
                                }
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Rejected reason"
                              : undefined
                          }
                          alerts={buildAlerts()}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : noTransactionsFromAPI ? (
              <div className=" flex flex-col gap-gap-sm justify-center items-center m-auto">
                <div className=" flex flex-col items-center justify-end">
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="No accounts found"
                    className={"w-graphic-width-md h-graphic-square-height-md"}
                  />
                </div>

                <div className="flex flex-col gap-gap-sm items-center">
                  <p className="text-text-primary text-font-sm font-normal">
                    There are no pending accounts for your approval.
                  </p>

                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Tax account dashboard"
                    btnType="button"
                    handleFunction={() => navigate("/tax_account_dashboard")}
                    enabledTextColor="var(--text-primary)"
                  />
                </div>
              </div>
            ) : null}
            <div className="h-pagination-height flex-shrink-0"></div>
          </div>
          {!allTaxAccountLoading &&
            !noResultsAfterFilter &&
            !noTransactionsFromAPI && (
              <div
                className={`w-width-full bottom-bottom-base fixed ${
                  accumulatedData?.length ===
                    GlobalConfiguration.lengthCheckZero &&
                  filteredData?.length ===
                    GlobalConfiguration.lengthCheckZero &&
                  !loading &&
                  noResultsAfterFilter
                    ? "hidden"
                    : "block"
                } ${isSidebarOpen ? " z-z-index-base" : "z-z-index-content"}`}
              >
                {showInnerSearchBar && (
                  <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                )}
                <div
                  className={`${(isSidebarOpen || showInnerSearchBar) && "pointer-events-none"}`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default TaxationAccountApproval;
